module.exports = __webpack_public_path__ + "media/src/images/speech-bubble-ec5c61769f90c6105714d7fd3b0d75eb.svg";